import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { solutions } from "../../../assets/images";
import AOS from "aos";
import "aos/dist/aos.css";

const Solutions = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: false,
      offset: 300,
    });
  }, []);

  return (
    <div
      data-aos="fade-up"
      className="mt-[56px] md:mt-[88px] overflow-x-hidden"
    >
      {/* Background image container */}
      <div
        className="relative w-full h-[204px] md:h-[406px] bg-cover bg-center flex items-center"
        style={{ backgroundImage: `url(${solutions})` }}
      >
        {/* Overlay (istəyə görə tündləşdirmə) */}

        {/* Text */}
        <div
          data-aos="fade-right"
          className="relative z-10 w-[337px] md:w-[866px] flex justify-center text-center mx-auto"
        >
          <h2 className="text-white text-[28px] md:text-[50px] font-medium md:font-semibold font-secondFont">
            {t("Məqsədimiz sizin üçün Etibarlı və Rahat Məkanlar Yaratmaqdır")}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Solutions;
